import React, { useState, useEffect } from 'react';
import NavigationNode from './NavigationNode';
import { defaultNavigation } from './NavigationNodeData';
import styles from './ProgressNavigationBar.module.css';

type Props = {
  viewSize: string,
  replenishment: boolean,
};

const ProgressNavigationBar = ({ viewSize, replenishment }: Props) => {
  const [currentNode, setCurrentNode] = useState(-1);

  const getCurrentNode = () => {
    const url = window.location.href;

    const index = defaultNavigation.findIndex((x) => {
      return url.includes(x.url);
    });
    setCurrentNode(index);
  };

  useEffect(() => {
    getCurrentNode();
  }, []);

  const getNavigation = () =>
    defaultNavigation
      .map((navItem) => {
        if (!replenishment && navItem.title === 'reFills') {
          return;
        }
        return navItem;
      })
      .filter((x) => x !== undefined);
  const nodes = getNavigation();

  return (
    <div className={`${styles.navigation} ${styles[viewSize]}`}>
      {nodes.map((node, index) => {
        const selected = index <= currentNode;
        return (
          <NavigationNode
            key={node.title}
            number={`${index + 1}`}
            item={node}
            selected={selected}
          />
        );
      })}
    </div>
  );
};

export default ProgressNavigationBar;
